"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spinner = void 0;
var tslib_1 = require("tslib");
var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");
var ui_helper_with_space_1 = require("@hopin-team/ui-helper-with-space");
var lottie_react_1 = (0, tslib_1.__importDefault)(require("lottie-react"));
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var logo_json_1 = (0, tslib_1.__importDefault)(require("./logo/logo.json"));
var root_1 = require("./styled/root");
var getStatus = function (_a) {
    var isPolite = _a.isPolite, isAssertive = _a.isAssertive;
    if (isPolite) {
        return 'status';
    }
    if (isAssertive) {
        return 'alert';
    }
    return '';
};
var getLive = function (_a) {
    var isPolite = _a.isPolite, isAssertive = _a.isAssertive;
    if (isPolite) {
        return 'polite';
    }
    if (isAssertive) {
        return 'assertive';
    }
    return 'off';
};
var Spinner = function (_a) {
    var __UIScope = _a.__UIScope, testID = _a["data-testid"], className = _a.className, isAssertive = _a.isAssertive, isPolite = _a.isPolite, isShowing = _a.isShowing, _b = _a.label, label = _b === void 0 ? 'Loading…' : _b, _c = _a.pattern, pattern = _c === void 0 ? 'mini' : _c, _d = _a.theme, theme = _d === void 0 ? 'primary' : _d, props = (0, tslib_1.__rest)(_a, ["__UIScope", 'data-testid', "className", "isAssertive", "isPolite", "isShowing", "label", "pattern", "theme"]);
    var rootClasses = (0, ui_helper_deep_branding_1.useEscapeClasses)({
        block: Spinner.name,
        className: className,
        __UIScope: __UIScope,
    }).rootClasses;
    return (react_1.default.createElement("div", (0, tslib_1.__assign)({ "data-testid": testID, "aria-live": getLive({ isAssertive: isAssertive, isPolite: isPolite }) }, props),
        isShowing && (react_1.default.createElement(root_1.Root, { className: rootClasses, pattern: pattern, role: getStatus({ isAssertive: isAssertive, isPolite: isPolite }), "aria-label": label, theme: theme })),
        isShowing && pattern === 'logo' && (react_1.default.createElement(lottie_react_1.default, { className: rootClasses, animationData: logo_json_1.default, role: getStatus({ isAssertive: isAssertive, isPolite: isPolite }), "aria-label": label }))));
};
var SpinnerWithSpace = (0, ui_helper_with_space_1.withSpace)(Spinner);
exports.Spinner = SpinnerWithSpace;
//# sourceMappingURL=spinner.js.map